/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import styles from './EvidenceReview.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { EvidenceReviewProps } from './EvidenceReview.types';

export const EvidenceReview = ({ topic, className }: EvidenceReviewProps) => {
  const { t } = useInt();

  const hasChecklist = topic.evidence_checklist.length > 0;

  if (!hasChecklist && !topic.review_output && !topic.family_review) {
    return null;
  }

  return (
    <SectionShell id="evidence-review" title={t('Evidence and review output')} className={className}>
      {hasChecklist && (
        <div className={styles['block']}>
          <h3 className={styles['label']}>{t('Review these')}</h3>
          <ul className={styles['checklist']}>
            {topic.evidence_checklist.map((item, index) => (
              <li key={index} className={styles['item']}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}

      {topic.review_output && (
        <div className={cn(styles['block'], styles['output'])}>
          <h3 className={styles['label']}>{t('The review should produce')}</h3>
          <p className={styles['text']}>{topic.review_output}</p>
        </div>
      )}

      {topic.family_review && (
        <div className={cn(styles['block'], styles['family'])}>
          <h3 className={styles['label']}>{t('Across this family')}</h3>
          <p className={styles['text']}>{topic.family_review}</p>
        </div>
      )}
    </SectionShell>
  );
};
